<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title class="my-4 justify-center">
        <span class="gray--text" v-text="$t('limit.title')"></span>
      </v-card-title>
      <v-card-text>

        <p class="black--text" v-html="$t('limit.text')"></p>
        <br />
        <v-btn
          depressed
          block
          tile
          @click="close"
          color="primary"
          v-text="$t('limit.back')"
          class="btn_download2 mb-4"
        >
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LimitDialog",
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
